import React from 'react'
import OnboardingStep1Img from '../../assets/images/onboarding_step_1.svg';
import Button from '../buttons/Button';
import { useDispatch, useSelector } from 'react-redux';
import { setOnBoardingSteps } from '../../redux/onBoardingSlice';
import closeIcon from '../../assets/images/CloseIcon.svg'
import { useUpdateUserData } from '../../services/userDataService';
import partySvg from '../../assets/images/Party 1.svg';

// Welcome to portrait
export const OnBoardingStep1 = () => {
    const updateUserData = useUpdateUserData();

    const dispatch = useDispatch();

    const { userData } = useSelector((state) => state.auth);
   
    const onBoardingData = {
        email: userData?.email,
        username: userData?.username,
        onboardingCheck: true
    };

    const updateOnBoarding = async () => {
        await updateUserData(onBoardingData)
        dispatch(setOnBoardingSteps(0))
    }

    return (
        <div className="absolute z-[999] h-full w-full flexCenter">
            <div className='relative h-[288px] w-[670px] px-[40px] pt-[40px] bg-white rounded-[16px] flex items-center gap-[40px]'>
                <img src={closeIcon} alt="" className='absolute top-5 right-5 cursor-pointer' onClick={updateOnBoarding} />

                <img className='w-[148px] h-[250px]' src={OnboardingStep1Img} alt="on boarding step 1" />
                <div className='h-[184px] flex flex-col self-start justify-between gap-[40px]'>
                    <div className='w-[402px] flex flex-col gap-[24px]'>
                        <h1 className='w-fit font-helveticaText-Medium text-[28px] leading-[32px] font-[500] flex gap-2'>
                            {/* Welcome to Portr<span className="font-helveticaDisp-Bold-Italics">ai</span>t */}
                            Welcome to Portrait.
                            <img className='h-[30px] w-[30px]' src={partySvg} alt="" />
                            {/* <span className='font-helveticaText-Medium text-[28px] leading-[32px] font-[500] text-pink-primary'>{" "}</span> */}
                        </h1>
                        <p className='w-[408px] text-cus_secondary leading-[24px] tracking-[-0.02em]'>While we bring your font ideas to life, take a moment to explore how to make the most of Monotype Portrait.</p>
                    </div>
                    <div className='h-[48px] flex gap-[24px]'>
                        <Button onClick={() => dispatch(setOnBoardingSteps(2))} label="Let's go" className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[16px] py-[12px] " />
                        <button onClick={() => updateOnBoarding()} className='font-helveticaText-Medium leading-[24px] text-cus_secondary tracking-[-0.02em]'>Skip tutorial</button>
                    </div>
                </div>
            </div>
        </div >
    )
}

// How to use Prompt Box
export const OnBoardingStep2 = () => {
    const updateUserData = useUpdateUserData();

    const dispatch = useDispatch();

    const { userData } = useSelector((state) => state.auth);
    const { promptBoxHeight } = useSelector((state) => state.toaster);

    const onBoardingData = {
        email: userData?.email,
        username: userData?.username,
        onboardingCheck: true
    };

    const updateOnBoarding = async () => {
        await updateUserData(onBoardingData)
        dispatch(setOnBoardingSteps(0))
    }
    return (
        <div style={{bottom:promptBoxHeight + 38}} className='absolute left-[24px] bg-white z-30  w-[464px] p-[40px] flex flex-col gap-[40px] rounded-lg'>
            <img src={closeIcon} alt="" className='absolute top-5 right-5 cursor-pointer' onClick={updateOnBoarding} />

            <div className='w-full flex flex-col gap-[24px]'>
                <h1 className="font-helveticaText-Medium font-[500] text-[24px] leading-[32px]">Play around and explore!</h1>
                <p className="text-gray-600 leading-[24px] tracking-[-0.02em]">
                    You can try new ideas by changing your prompts from here. The more detailed you're, the better your results will be.
                </p>
            </div>
            <div className='flex items-center gap-[16px]'>
                <Button onClick={() => dispatch(setOnBoardingSteps(3))} label='Next' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[16px] py-[12px] " />
                <p className='text-cus_secondary font-helveticaText-Medium leading-[24px] tracking-[-0.02em]'>1/5</p>
            </div>
        </div>
    )

}

// Recommended fonts without hover
export const OnBoardingStep3 = () => {
    const updateUserData = useUpdateUserData();

    const dispatch = useDispatch();

    const { userData } = useSelector((state) => state.auth);

    const onBoardingData = {
        email: userData?.email,
        username: userData?.username,
        onboardingCheck: true
    };

    const updateOnBoarding = async () => {
        await updateUserData(onBoardingData)
        dispatch(setOnBoardingSteps(0))
    }
    return (
        <div className="absolute left-[408px] z-20 h-[264px] max-w-[457px] p-[40px] bg-white rounded-[16px]">
            <img src={closeIcon} alt="" className='absolute top-5 right-5 cursor-pointer' onClick={updateOnBoarding} />
            <div className='h-[184px] w-[377px] flex flex-col gap-[40px] rounded-lg'>
                <div className='flex flex-col gap-[24px]'>
                    <h1 className="font-helveticaText-Medium font-[500] text-[24px] leading-[32px]">Recommended fonts.</h1>
                    <p className="text-gray-600  leading-[24px] tracking-[-0.02em]">
                        Here, you can browse a curated list of fonts tailored by us to match your prompt.
                    </p>
                </div>
                <div className='flex items-center gap-[16px]'>
                    <Button onClick={() => dispatch(setOnBoardingSteps(4))} label='Next' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[16px] py-[12px] " />
                    <p className='text-cus_secondary font-helveticaText-Medium leading-[24px] tracking-[-0.02em]'>2/5</p>
                </div>
            </div>
        </div>
    )
}

// Recommended fonts with hover
export const OnBoardingStep4 = () => {
    const updateUserData = useUpdateUserData();

    const dispatch = useDispatch();

    const { userData } = useSelector((state) => state.auth);

    const onBoardingData = {
        email: userData?.email,
        username: userData?.username,
        onboardingCheck: true
    };

    const updateOnBoarding = async () => {
        await updateUserData(onBoardingData)
        dispatch(setOnBoardingSteps(0))
    }
    return (
        <div className="absolute left-[408px] z-20 h-[296px] w-[474px] p-[40px] bg-white rounded-[16px]">
            <img src={closeIcon} alt="" className='absolute top-5 right-5 cursor-pointer' onClick={updateOnBoarding} />
            <div className='h-[216px] w-[394px] flex flex-col gap-[40px] rounded-lg'>
                <div className='flex flex-col gap-[24px]'>
                    <h1 className="w-[380px] font-helveticaText-Medium font-[500] text-[23px] leading-[32px]">See recommended fonts in context.</h1>
                    <p className="text-gray-600 leading-[24px] tracking-[-0.02rem]">
                        If you'd like to see a visual generated with a font from the recommended list, you can do that from here!
                    </p>
                </div>
                <div className='flex items-center gap-[16px]'>
                    <Button onClick={() => dispatch(setOnBoardingSteps(5))} label='Next' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[16px] py-[12px] " />
                    <p className='text-cus_secondary font-helveticaText-Medium leading-[24px] tracking-[-0.02em]'>3/5</p>
                </div>
            </div>
        </div>
    )
}

// generated image 
export const OnBoardingStep5 = (imageModalWidth) => {
    
    
    const updateUserData = useUpdateUserData();

    const dispatch = useDispatch();

    const { userData } = useSelector((state) => state.auth);

    const onBoardingData = {
        email: userData?.email,
        username: userData?.username,
        onboardingCheck: true
    };

    const updateOnBoarding = async () => {
        await updateUserData(onBoardingData)
        dispatch(setOnBoardingSteps(0))
    }
    
    return (
        <div className={`absolute -top-5  max-w-[457px] mt-[16px] p-[40px] bg-white rounded-[16px] z-50`} style={{ left: `${Math.round(imageModalWidth?.imageModalWidth + 10)}px` }}>
            <img src={closeIcon} alt="" className='absolute top-5 right-5 cursor-pointer' onClick={updateOnBoarding} />
            <div className=' w-[377px] flex flex-col gap-[40px] rounded-lg'>
                <div className='flex flex-col gap-[24px]'>
                    <h1 className="font-helveticaText-Medium font-[500] text-[24px] leading-[32px]">From prompt to visual reality.</h1>
                    <p className="text-gray-600  leading-[24px] tracking-[-0.02em]">
                        Here's your generated font visualization and inspiration. Feel free to leave your feedback on this image, and we'll keep improving it for you!
                    </p>
                </div>
                <div className='flex items-center gap-[16px]'>
                    <Button onClick={() => dispatch(setOnBoardingSteps(6))} label='Next' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[16px] py-[12px] " />
                    <p className='text-cus_secondary font-helveticaText-Medium leading-[24px] tracking-[-0.02em]'>4/5</p>
                </div>
            </div>
        </div>
    )
}

// tips for best results
export const OnBoardingStep6 = () => {
    const updateUserData = useUpdateUserData();

    const dispatch = useDispatch();

    const { userData } = useSelector((state) => state.auth);

    const onBoardingData = {
        email: userData?.email,
        username: userData?.username,
        onboardingCheck: true
    };

    const updateOnBoarding = async () => {
        await updateUserData(onBoardingData)
        dispatch(setOnBoardingSteps(0))
    }
    return (
        <div className="absolute -top-[10px] right-[80px] max-w-[464px] mt-[16px] p-[40px] z-[99] bg-white rounded-[16px]">
            <img src={closeIcon} alt="" className='absolute top-5 right-5 cursor-pointer' onClick={updateOnBoarding} />
            <div className=' w-[384px] flex flex-col gap-[40px] rounded-lg'>
                <div className='flex flex-col gap-[24px]'>
                    <h1 className="font-helveticaText-Medium font-[500] text-[24px] leading-[32px]">Get the best results.</h1>
                    <p className="text-gray-600  leading-[24px] tracking-[-0.02em]">
                        Check out this section for tips on refining your prompts and achieving better, more accurate visuals!
                    </p>
                </div>
                <div className='flex items-center gap-[16px]'>
                    <Button
                        onClick={updateOnBoarding}
                        label="Done"
                        className="bg-gray-light hover:bg-gray-hoverLight text-cus_primary"
                    />
                    {/* <Button onClick={() => dispatch(setOnBoardingSteps(5))} label='Next' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[16px] py-[12px] " /> */}
                    <p className='text-cus_secondary font-helveticaText-Medium leading-[24px] tracking-[-0.02em]'>5/5</p>
                </div>
            </div>
        </div>
    )
}